// Plain text helpers for the game page. Dates are formatted by hand: Intl's
// short months differ between engines ("Sep" / "Sept"), and a dayKey is a
// calendar day, so it must not shift with the viewer's time zone.

const WEEKDAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

function parseDayKey(dayKey: string): Date | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dayKey);
  if (!m) return null;
  return new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3])));
}

/** "17 November" */
export function fmtDay(dayKey: string): string {
  const d = parseDayKey(dayKey);
  if (!d) return dayKey;
  return `${d.getUTCDate()} ${MONTHS[d.getUTCMonth()]}`;
}

/** "Tuesday 17 November" */
export function fmtDayWithWeekday(dayKey: string): string {
  const d = parseDayKey(dayKey);
  if (!d) return dayKey;
  return `${WEEKDAYS[d.getUTCDay()]} ${fmtDay(dayKey)}`;
}

/** "17 November" for an ISO instant, in the viewer's local calendar. */
export function fmtInstantDay(iso: string | null | undefined): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return `${d.getDate()} ${MONTHS[d.getMonth()]}`;
}

/** 1 -> "1st", 2 -> "2nd", 11 -> "11th" */
export function ordinal(n: number): string {
  const mod100 = n % 100;
  if (mod100 >= 11 && mod100 <= 13) return `${n}th`;
  switch (n % 10) {
    case 1:
      return `${n}st`;
    case 2:
      return `${n}nd`;
    case 3:
      return `${n}rd`;
    default:
      return `${n}th`;
  }
}

/** 2 -> "double points", 3 -> "triple points", 1.5 -> "1.5x points" */
export function multiplierText(multiplier: number): string {
  if (multiplier === 2) return "double points";
  if (multiplier === 3) return "triple points";
  return `${multiplier}x points`;
}

/** "45 morning races, 17 November to 31 December." */
export function seasonSpan(totalDays: number, dayKeyFrom: string, dayKeyTo: string): string {
  return `${totalDays} morning races, ${fmtDay(dayKeyFrom)} to ${fmtDay(dayKeyTo)}.`;
}

/** "1 point" / "5 points" */
export function pointsWord(n: number): string {
  return n === 1 ? "1 point" : `${n} points`;
}

/** "=2" when another row shares the rank, "2" otherwise, "-" before any day settles. */
export function rankLabel(rank: number | null, shared: boolean): string {
  if (rank == null) return "-";
  return shared ? `=${rank}` : String(rank);
}
